// In-memory cache of already-fetched listing data, keyed per view. When the
// user returns via Back/Forward we hydrate the page from here so it paints the
// same list instantly instead of refetching from the API (the refetch left the
// page empty for a few seconds, so scroll restoration had no card to land on and
// the user saw the header/footer first). Cleared on a full page reload — fine,
// because Back/Forward inside the SPA keeps this module alive.
const cache = new Map();

export const getPageCache = (key) => cache.get(key);
export const setPageCache = (key, value) => cache.set(key, value);
